import { createSelector } from 'reselect'

export const selectUserGear = (state) => state.userGear.gear

export const selectUserGearOptions = (retired = false) => createSelector(
  selectUserGear,
  (userGear) => userGear
    .filter(gear => retired || !gear.retired)
    .map(gear => ({
      label: gear.name,
      value: gear._links.self[0].href,
    })),
)



// WEBPACK FOOTER //
// ./src/services/userGear/selectors.js